import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'

import { BlueHeader } from '@/components/layout/blue-header'
import { ResearchBarFormShell } from '@/components/research-bar/research-bar-form-shell'

export const Route = createFileRoute('/recherche')({
  component: ResearchBarComponent,
})

export function ResearchBarComponent() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  if (pathname !== '/recherche') {
    return <Outlet />
  }

  return (
    <div className="flex min-h-screen min-w-screen flex-1 flex-col gap-5 bg-[url('/images/default-background.jpg')] bg-cover bg-center bg-no-repeat">
      <div>
        <BlueHeader />
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-5">
        {/* Plafonné : sans max-width la barre s'étirerait sur toute la largeur
            d'un très grand écran ; sans w-full elle se réduirait à son contenu
            (~620 px) et tronquerait les libellés d'aéroport. items-stretch est
            nécessaire jusqu'en desktop, sinon le formulaire reste à sa largeur
            de contenu à l'intérieur de la carte élargie. */}
        <ResearchBarFormShell className="w-[95vw] items-stretch md:w-full md:max-w-[1100px]" />
        <div className="rounded-full bg-black/20 px-3 py-0.5 text-sm font-medium text-white shadow-[0_0_20px_10px_rgba(0,0,0,0.2)]">
          ou
        </div>
        <Link
          className="rounded-full bg-[#4893B3] px-12 py-4 text-lg text-white transition-colors hover:bg-[#3A7E9C]"
          to="/devis"
        >
          Faire un devis sur mesure →
        </Link>
        <span className="rounded-2xl bg-black/20 px-4 py-1 text-center text-sm font-medium text-white shadow-[0_0_20px_10px_rgba(0,0,0,0.2)]">
          (Congés Bonifiés, UM, Groupes, Plusieurs départs, Demandes particulières…)
        </span>
      </div>
    </div>
  )
}
